/**
 * 版本字串的格式預檢（批141-S）——與後端 `api/admin_agent_kinds.py::_SEMVER_RE` **逐字同一條**規則：
 * semver `MAJOR.MINOR.PATCH`（數字不補零），可帶 `-pre`／`+build`。
 *
 * 前端只做格式預檢（打字當下就提示，不必等送出才 422）；權威仍在後端。
 * 空白不在這裡判——呼叫端自己決定空白的語意（agent 種類的三個版本欄：空白＝不設）。
 *
 * - ✓ `0.2.15`、`0.0.0`、`1.0.0-rc.1`、`1.2.3+build.5`
 * - ✗ `v0.2.15`、`0.2`、`0.2.15 garbage`、`01.2.3`（前導零）
 */
const SEMVER_RE =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-[0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*)?(?:\+[0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*)?$/

export function isSemver(value: string): boolean {
  return SEMVER_RE.test(value)
}

/**
 * 選填版本欄的預檢：空白（trim 後）＝合法（不設）；有值就必須是 semver。
 * 回錯誤訊息，合法回 `null`。
 */
export function optionalSemverError(value: string): string | null {
  const v = value.trim()
  if (!v) return null
  return isSemver(v) ? null : '格式不合：只收 semver「數字.數字.數字」（例：0.2.15）'
}
